import { HubsLogbook } from "Models";
import { NewRequestForm } from 'Components';
import { Form, useRequireFieldValidation } from "@cae/component-library";
import { TFunction } from 'react-i18next';

export const EditRequestForm = (t: TFunction<'forms'>, isAdmin: boolean): Form => {
    const requireFieldValidation = useRequireFieldValidation(t);
    
    return {
        ...NewRequestForm(t, isAdmin),
        "status": {
            label: t('editRequestForm.status'),
            value: "",
            validations: [requireFieldValidation],
            fieldType: "select",
            placeHolder: t('editRequestForm.status'),
            options: []
        }
}};

export const ConvertEditRequestFormToHubsLogbookModel = (hubsLogbook: HubsLogbook, editRequestForm: Form): HubsLogbook => {
    Object.keys(editRequestForm).forEach(formKey => {
        hubsLogbook[formKey] = editRequestForm[formKey].value;
    })

    return hubsLogbook;
}